(function(global, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(global);
    }
})(typeof window !== 'undefined' ? window : this, function(window) {
    var cpac = {};

    cpac.unknownProfileId = -1;
    cpac.showLog = true,
    
    cpac.error = function (e) {
        if (window.console && console.error) {
            console.error(e);
        } else {
            alert(e.name + ': ' + e.message);
        }
    };
    
    cpac.log = function (msg) {
        if (this.showLog && window.console && console.log) {
            console.log(msg);
        }
    };
   
    window.cpac = cpac;
    return cpac;
});

